import { render, staticRenderFns } from "./job-details.vue?vue&type=template&id=58a009e6"
import script from "./job-details.vue?vue&type=script&lang=js"
export * from "./job-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports